import { ClinicianDashboardRoutes } from '@shared/common/routing/clinician-dashboard-routes';
import { IRouteStructure } from '@shared/common/routing/IRouteStructure';

export const SETTINGS_NAVIGATION_ITEMS: IRouteStructure[] = [
  {
    ...ClinicianDashboardRoutes.ACCOUNT_SETTINGS.view,
    translationDefault: 'Profile',
    section: 'account',
  },
  {
    ...ClinicianDashboardRoutes.SECURITY_DEVICES.view,
    translationDefault: 'Security & Devices',
    section: 'account',
  },
  {
    ...ClinicianDashboardRoutes.PRACTICE_PROFILE.view,
    translationDefault: 'Practice profile',
    section: 'workspace',
  },
  {
    ...ClinicianDashboardRoutes.WORKSPACE_SETTINGS.view,
    translationDefault: 'Workspace settings',
    section: 'workspace',
  },
];

export function getAccessibleSettingsNavigationItems(): IRouteStructure[] {
  return SETTINGS_NAVIGATION_ITEMS;
}

export function getFirstAccessibleSettingsNavigationItem(): IRouteStructure | null {
  return SETTINGS_NAVIGATION_ITEMS[0] ?? null;
}

export function isSettingsNavigationUrl(url: string): boolean {
  const normalizedUrl = normalizeUrl(url);
  const items = [
    ...SETTINGS_NAVIGATION_ITEMS,
    {
      ...ClinicianDashboardRoutes.ORGANISATION_SETTINGS.view,
      translationDefault: 'Organisation settings',
    },
  ];

  return items.some(item => {
    const itemUrl = normalizeUrl(item.fullUrl as string);
    return normalizedUrl === itemUrl || normalizedUrl.startsWith(`${itemUrl}/`);
  });
}

function normalizeUrl(url: string): string {
  return (url ?? '').split('?')[0].split('#')[0];
}
